import React from 'react';
import { Input, Button, PaperClip, Select, Modal } from 'components';
import { ServiceService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { WhiteImage } from 'assets/img';
import { AddIcon } from 'assets/icons';
import ModalSpecialities from './modal-specialities';
import ModalAreas from './modal-areas';

interface Props {
	onClose?: any;
	item?: any;
	type_id?: number;
}

class CreateService extends React.Component<Props> {

	state = {
		form: {
			name: '',
	        photo: '',
	        type_id: '',
	        area_id: '',
	        speciality_id: ''
		},
		service_types: [],
		areas: [],
		specialities: [],
		visible: false,
		visible_area: false
	}

	async componentDidMount() {
		if (this.props.item) {
			this.setState({
				form: {
					...this.state.form,
					name: this.props.item?.name || '',
					type_id: this.props.item?.type_id || '',
					area_id: this.props.item?.area_id || '',
					speciality_id: this.props.item?.speciality_id || ''
				},
				item: this.props.item
			});
		}
		else {
			this.setState({
				form: {
					...this.state.form,
					type_id: this.props.type_id || ''
				}
			});
		}

		this.load();
		this.loadAreas();
	}

	load = async () => {
		const res: any = await ServiceService.admin.getTypes();
		this.setState({
			service_types: res.service_types
		});
	}

	loadAreas = async () => {
		const res: any = await ServiceService.admin.getAreas({
			withoutLoading: true
		});
		this.setState({
			specialities: res.specialities || [],
			areas: res.areas || []
		});
	}

	submit = async (e: any) => {
		e.preventDefault();
		if (this.props.item != null) {
			await ServiceService.admin.edit({
				service_id: this.props.item?.id,
				...this.state.form,
				hasFile: true,
				// @ts-ignore,
				photo: this.state.form.photo?.value || '',
			});
			Globals.showSuccess("Se ha modificado el servicio correctamente");
			this.props.onClose();
		}
		else {
			if (!this.state.form.photo) {
				Globals.showError("Debe ingresar la foto del servicio");
				return;
			}

			await ServiceService.admin.create({
				...this.state.form,
				hasFile: true,
				// @ts-ignore,
				photo: this.state.form.photo?.value || '',
			});
			Globals.showSuccess("Se ha creado el servicio correctamente");
			this.props.onClose();
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	onClose = () => {
		this.setState({
			visible: false
		},() => {
			this.loadAreas();
		});
	}

	onCloseArea = () => {
		this.setState({
			visible_area: false
		},() => {
			this.loadAreas();
		});
	}
	
	render() {
		const { visible_area, visible } = this.state;

		return (
			<div id="modal-create-service">
				<Modal
		          className="modal-create-speciality-service"
		          visible={ visible }
		          title="Especialidades"
		          animation={ false }
		          onClose={ () => this.onClose() }
		        >
		          {/* 
		          // @ts-ignore */}
		          <ModalSpecialities
		            onClose={ () => this.onClose() } />
		      	</Modal>

		      	<Modal
		          className="modal-create-speciality-service"
		          visible={ visible_area }
		          title="Unidades"
		          animation={ false }
		          onClose={ () => this.onCloseArea() }
		        >
		          {/* 
		          // @ts-ignore */}
		          <ModalAreas
		            onClose={ () => this.onCloseArea() } />
		      	</Modal>

		      	{
		      		!visible && !visible_area && (
		      			<form onSubmit={ this.submit }>
							<div className="container-image">
								<PaperClip
									className="paperclip-image"
									value={ this.state.form.photo }
									width={ 450 }
									height={ 450 }
									size={ 500 }
									onChange={ (e: any) => {
										this.setState({
											form: {
												...this.state.form,
												photo: e.target
											}
										})
									} }>
									{/*
									// @ts-ignore */}
									<img className={ `selected-image ${ (this.state.form.photo || this.state.item?.photo) ? '' : 'inactive' }` } src={ this.state.form.photo?.dataURL || (this.state.item?.photo ? (Constants.BASE_STORAGE + this.state.item?.photo) : WhiteImage) } />
								</PaperClip>
								<p className="photo-title">Foto del servicio</p>
							</div>
							<p className="subtitle">La imagen debe ser formato JPG o PNG de 500kb, como máximo de 450px por 450px</p>
							<Input
								color="white"
								value={ this.state.form.name }
								name="name" 
								label="Nombre"
								onChange={ this.change } />
							<div className="container-select">
								<Select
									placeholder="Seleccionar"
									label="Unidad (Opcional)"
									name="area_id"
									onChange={ this.change }
									value={ this.state.form.area_id }
									options={ this.state.areas.map((i: any) => {
										return {
											value: i.id,
											label: i.name
										}
									}) } />
								<Button className="add-icon" type="button" onClick={ () => {
									this.setState({
										visible_area: true
									});
								} }>
									<img src={ AddIcon } />
								</Button>
							</div>
							<div className="container-select">
								<Select
									placeholder="Seleccionar"
									label="Especialidad (Opcional)"
									name="speciality_id"
									onChange={ this.change }
									value={ this.state.form.speciality_id }
									options={ this.state.specialities.map((i: any) => {
										return {
											value: i.id,
											label: i.name
										}
									}) } />
								<Button className="add-icon" type="button" onClick={ () => {
									this.setState({
										visible: true
									});
								} }>
									<img src={ AddIcon } />
								</Button>
							</div>
							<Select
								label="Tipo de Servicio"
								name="type_id"
								onChange={ this.change }
								value={ this.state.form.type_id }
								options={ this.state.service_types.map((i: any) => {
									return {
										value: i.id,
										label: i.name
									}
								}) } />
							<div className="row row-buttons">
								<div className="col-md-6 text-center">
									<Button type="button" onClick={ () => this.props.onClose() }>
										Cerrar
									</Button>
								</div>
								<div className="col-md-6 text-center">
									<Button type="submit">
										Guardar
									</Button>
								</div>
							</div>
						</form>
		      		)
		      	}
			</div>
		)
	}
}

export default CreateService;